import React, { FC, useEffect } from 'react';
import { Document, Page, Text, View, StyleSheet, Link } from '@react-pdf/renderer';
import {QuestionaireType} from '../constants/enums'
import moment from 'moment';

const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
      },
    title: {
        fontSize: 24,
        textAlign: 'center',
        marginBottom: 20,
      },
    view: {
        flexDirection: 'column',
        marginBottom: 10
    },
    QuestionaireView: {
        flexDirection: 'row',
        marginBottom: 5
    },
    QuestionTitle: {
        fontSize: 20,
        fontWeight: 'black'
    },
	section: {
		flexGrow: 1,
	},
});

const QuestionView: FC<{question: any, index: any}>= ({question, index})=>{
    return (
        <View style={styles.QuestionaireView}>
            <Text style={styles.QuestionTitle} >Question:</Text>
            <Text style={{marginTop: 1, marginLeft: 5}} >{question.name}</Text>
        </View>
    );
 };

 const TextTypeView: FC<{question: any, index}>= ({question, index })=>{
    return (
        <View style={styles.QuestionaireView}  key={index}>
            <Text style={styles.QuestionTitle}>Answer:</Text>
            <Text style={{marginTop: 1, marginLeft: 12}} >{question.value}</Text>
        </View>
    );
 };

 const CurrencyTypeView: FC<{question: any, index}>= ({question, index })=>{
    return (
        <View style={styles.QuestionaireView}  key={index}>
            <Text style={styles.QuestionTitle}>Answer:</Text>
            <Text style={{marginTop: 1, marginLeft: 12}} >{question.value + ' ' + question.options[0]}</Text>
        </View>
    );
 };

 const TagTypeView: FC<{question: any, index}>= ({question, index })=>{
    return (
        <View style={styles.QuestionaireView}  key={index}>
            <Text style={styles.QuestionTitle}>Answer:</Text>
            {
                question.value.map((val, i)=>{
                    return <Text style={{marginTop: 1, marginLeft: 12}} key={i}>{val}</Text>
                })
            }
           
        </View>
    );
 };

 const MultipleChoiceTypeView: FC<{question: any, index}>= ({question, index })=>{
    return (
        <View style={styles.QuestionaireView}  key={index}>
            <Text style={styles.QuestionTitle}>Answer:</Text>
            { question.multi ?
                question.value.map((val, i)=>{
                    return <Text style={{marginTop: 1, marginLeft: 12}} key={i}>{val}</Text>
                })
                : 
                <Text style={{marginTop: 1, marginLeft: 12}} >{question.value}</Text>
            }
           
        </View>
    );
 };

 const DateTimeTypeView: FC<{question: any, index}>= ({question, index })=>{
    return (
        <View style={styles.QuestionaireView}  key={index}>
            <Text style={styles.QuestionTitle}>Answer:</Text>
            <Text style={{marginTop: 1, marginLeft: 12}} >{moment(question.value).format('MMMM Do YYYY, h:mm:ss a')}</Text>
        </View>
    );
 };

 const DateTypeView: FC<{question: any, index}>= ({question, index })=>{
    return (
        <View style={styles.QuestionaireView}  key={index}>
            <Text style={styles.QuestionTitle}>Answer:</Text>
            <Text style={{marginTop: 1, marginLeft: 12}} >{moment(question.value).format('MMMM Do YYYY')}</Text>
        </View>
    );
 };

 const TimeTypeView: FC<{question: any, index}>= ({question, index })=>{
  return (
      <View style={styles.QuestionaireView}  key={index}>
          <Text style={styles.QuestionTitle}>Answer:</Text>
              <Text style={{marginTop: 1, marginLeft: 12}} >{moment(question.value).format('h:mm:ss a')}</Text>
      </View>
  );
};

 const MediaTypeView: FC<{question: any, index}>= ({question, index })=>{
   return (
       <View style={styles.QuestionaireView}  key={index}>
           <Text style={styles.QuestionTitle}>Answer:</Text>
           <Text style={{marginTop: 1, marginLeft: 12}}>
			 <Link  src={question.value.url}>{question.value.name}</Link>
			</Text>
       </View>
   );
};

const LocationTypeView: FC<{question: any, index}>= ({question, index })=>{
    return (
        <View style={styles.QuestionaireView}  key={index}>
            <Text style={styles.QuestionTitle}>Answer:</Text>
            <Text style={{marginTop: 1, marginLeft: 12}} >Lat: {question?.value?.lat} Long: {question?.value?.lng}</Text>
        </View>
    );
 };

const NoAnswerView: FC<{question: any, index}>= ({question, index })=>{
    return (
        <View style={styles.QuestionaireView}  key={index}>
            <Text style={styles.QuestionTitle}>Answer:</Text>
            <Text style={{marginTop: 1, marginLeft: 12}} >N/A</Text>
        </View>
    );
 };

 
const MyDocument : FC<{ data?: any }> = ({ data }) => {
   
    const switchRenderer =(el, index)=>{
        if(el.value === '' || el.value === null || el.value === []){
            return <NoAnswerView
                question={el}
                index={index}
            />
        }else 
        {
            switch(el.type){
                case QuestionaireType.Bar:
                case QuestionaireType.Email:
                case QuestionaireType.Phone:
                case QuestionaireType.ThreeButton:
                case QuestionaireType.Name:
                case QuestionaireType.YesNo:
                case QuestionaireType.Text:
                    return <TextTypeView question={el} index={index} />;
                case QuestionaireType.MultipleChoice:
                    return <MultipleChoiceTypeView question={el} index={index} />;
                case QuestionaireType.Currency:
                    return <CurrencyTypeView question={el} index={index} />;
                case QuestionaireType.Tag:
                case QuestionaireType.TagNot:
                    return <TagTypeView question={el} index={index} />;
                case QuestionaireType.Signature:
                case QuestionaireType.Media:
                case QuestionaireType.File:  
                    return <MediaTypeView question={el} index={index} />;
                case QuestionaireType.DateTime:
                    return <DateTimeTypeView question={el} index={index} />;
                case QuestionaireType.Date:
                    return <DateTypeView question={el} index={index} />;
                case QuestionaireType.Time:
                    return <TimeTypeView question={el} index={index} />;
                case QuestionaireType.Location:
                    return <LocationTypeView question={el} index={index} />;
                case QuestionaireType.GPS:
                    return <LocationTypeView question={el} index={index} />;
                default:    
                  return <View style={styles.QuestionaireView}  key={index}>
                            <Text style={styles.QuestionTitle} >Answer:</Text>
                            <Text style={{marginTop: 1, marginLeft: 12}}> N/A</Text>
                        </View>;
            }
        }
        
    }

    const RenderQuestions = (data)=>{
        return  data.questions.map((el, index)=>{
           return ( 
            <View style={styles.view}   key={index}>
              <QuestionView 
                question={el}
                index={index}
              />
              {switchRenderer(el, index)}
            </View>
           )
        })         
    };

    return (
	<Document>
		<Page size="A4" style={styles.body}>
        <Text style={styles.title}>Survey</Text>
          {RenderQuestions(data)}
		</Page>
	</Document>
    );
};

export default MyDocument;